/***
 * PC_PFT_01
 * importing the getEmployeeFeedbacks, getDomain api functions
 */
import { useState, useEffect } from "react";
import React from "react";
import { getFeedbackDataSpecificFlag, getFlagCountAndName } from "../service/DirectorAPI";
import AddFeedback from "./AddFeedbackForm";
import moment from "moment";
import Loader from '../StaticComponent/Loader';

import { encryptStorage } from '../constant'

/**
 * PC_PFT_03 create a ProfileFeedbackTabGrid(props) function and export it
 * 
 */
export function ProfileFeedbackTabGrid(props) {

    /***
    * PC_PFT_02
    * declaring the state variables
    */
    let FeedbackGridarray = [];

    const [feedbackGridData, setFeedbackGridData] = useState(FeedbackGridarray);
    const [columnOrder, setColumnOrder] = useState("DESC");
    const [columnName, setColumnName] = useState("feedbacks.modified_at");
    const [sorthide, setsorthide] = useState("");
    const [dataLength, setdataLength] = useState(0);
    const [empId, setEmpId] = useState();
    const [countPerPage, setCoutPerPage] = useState(10);
    let login_id = encryptStorage.getItem("employeeId");
    let role = encryptStorage.getItem("role");
    const [isLoading, setIsLoading] = useState(true);
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let IsTeamMember = params.get('IsTeamMember');
    let [hideFeedbackForm, setHideFeedbackForm] = useState(true);
    const [EmployeeStatus, setEmployeeStatus] = useState(props.EmployeeStatus);



    let IndivFlagCounts = {
        green_flag: "",
        red_flag: "",
        yellow_flag: "",
        emp_name: "",
        domain: "",
        profile_img_url: ""
    };
    const [indivFlagCountsData, setIndivFlagCountsData] = useState(IndivFlagCounts);

    let filter = {
        flags: "",
        empResponse: "",
        startDate: "",
        endDate: ""
    };
    let [filterData, setFilterData] = useState(filter);

    /***
     * PC_PFT_03
     * UseEffect call the loadGridPage() and loadFlagCountPage() function
     */

    useEffect(() => {
        loadFlagCountPage();
        loadGridPage();
    }, [countPerPage, columnName, columnOrder]);


    /**
    * PC_PFT_03.2 loadFlagCountPage function get the data from database
    */
    const loadFlagCountPage = async () => {

        try {
            let login_id = encryptStorage.getItem("employeeId");
            let CurrentEvaluationId = encryptStorage.getItem("CurrentEvaluationId");
            setIsLoading(false);

            let empdata = {

                evaluation_id: CurrentEvaluationId,
                emp_id: props.empId, //emp_id
                login_emp_id: login_id
            };

            let data = await getFlagCountAndName(empdata);


            if (data.data != undefined && data.data != null && data.data.ResponseData != null && data.data.ResponseData.length != 0) {



                let IndivFlagCounts = {
                    green_flag: data.data.ResponseData[0].green_flag,
                    red_flag: data.data.ResponseData[0].red_flag,
                    yellow_flag: data.data.ResponseData[0].yellow_flag,
                    emp_name: data.data.ResponseData[0].emp_name,
                    domain: data.data.ResponseData[0].domain,
                    profile_img_url: data.data.ResponseData[0].profile_img_url
                };



                setIndivFlagCountsData(IndivFlagCounts);
            }

            if (data.data.status == 200) {
                setIsLoading(true);
            }

        } catch (e) {

        }
    };

    /**
    * PC_PFT_03.1 loadGridPage function retrive the data from database
    */
    const loadGridPage = async (filter = {}) => {

        if (filter?.flags === undefined) {
            filter = filterData
        }

        let CurrentEvaluationId = encryptStorage.getItem("CurrentEvaluationId");
        setEmpId(props.empId);
        try {
            let empdata = {
                evaluation_id: CurrentEvaluationId,
                emp_id: props.empId,
                sortOrder: columnOrder,
                sortColumn: columnName,
                PageSize: countPerPage,
                flags: filter.flags,
                emp_response: filter.empResponse,
                startDate: filter.startDate,
                endDate: filter.endDate

            };
            let data = await getFeedbackDataSpecificFlag(empdata);

            setFeedbackGridData(data.data.ResponseData[0]);
            setdataLength(data.data.ResponseData[1]);

        } catch (e) {

        }
    };
    function removeHTMLTags(input) {
        return input.replace(/<[^>]+>/g, '');
      }

    /**
    * 
    * @returns PC_PFT_10 this function bind the value into the grid
    */
    const feedbackGridBodyData = () => {
        try {


            if (feedbackGridData.length == 0) {
                return (
                    <tr>
                        <td colspan="10" className="accord-content1">
                            <div className="row justify-content-center">
                                <img src="/Images/nodatafound.png" alt="nodatafound" className="nofeedbackimg-sty" />
                                <h2 className="tt-bold font-15 text-center margin-negative">No Feedbacks Found</h2>
                            </div>
                        </td>
                    </tr>
                )
            }
            else {


                return feedbackGridData.map((obj, index) => {
                    let m = moment(new Date(obj.modified_at));
                    let FeeabackDate = m.format("MMM DD, YYYY");

                    var tipCount;
                    var commentsBind;
                    if (obj.comments.length > 15) {
                        commentsBind = obj.comments.substring(0, 15)
                        commentsBind = commentsBind + '...'
                        tipCount = 1;
                    }
                    else {
                        commentsBind = obj.comments
                        tipCount = 0;
                    }

                    const htmlText = '<p>This is a <strong>sample</strong> text with HTML tags.</p>'; const sanitizedText = removeHTMLTags(htmlText);
                    var comnttipCount;
                    var commentsbasedonBind;
                    if (obj.comments_based_on.length > 15) {
                        commentsbasedonBind = obj.comments_based_on.substring(0, 15)
                        commentsbasedonBind = commentsbasedonBind + '...'
                        comnttipCount = 1;
                    }
                    else {
                        commentsbasedonBind = obj.comments_based_on
                        comnttipCount = 0;
                    }

                    return (
                        <tr className="hive-table-data">


                            <td>{FeeabackDate}</td>

                            {obj.flags == "G" ? (<td className="text-center"><img src="/Images/profile-feedback-green.svg" className="profile-feedback-flag-size" alt="Flag Icon Green" /></td>) : null}
                            {obj.flags == "Y" ? (<td className="text-center"><img src="/Images/profile-feedback-yellow.svg" className="profile-feedback-flag-size" alt="Flag Icon Yellow" /></td>) : null}
                            {obj.flags == "R" ? (<td className="text-center"><img src="/Images/profile-feedback-red.svg" className="profile-feedback-flag-size" alt="Flag Icon Red" /></td>) : null}
                            {obj.flags == null || obj.flags == undefined ? (<td className="text-center"><span>-</span></td>) : null}

                            <td>{obj.feedbacked_by}</td>
                            {/* <td>{obj.comments_based_on}</td> */}
                            <td><a className={comnttipCount == 0 ? "tooltip-color tooltipCursor" : "tooltip-color"} data-bs-toggle="tooltip" data-bs-placement="top" title={comnttipCount == 1 ? obj.comments_based_on : ''}>{commentsbasedonBind}</a></td>
                            {/* <td> {obj.comments} </td> */}
                            <td><a className={tipCount == 0 ? "tooltip-color tooltipCursor" : "tooltip-color"} data-bs-toggle="tooltip" data-bs-placement="top" title={tipCount == 1 ?removeHTMLTags(obj.comments) : ''}> {removeHTMLTags(commentsBind)}  </a></td>
                            {/* <td><a className={tipCount == 0 ? "tooltip-color tooltipCursor" : "tooltip-color"} data-bs-toggle="tooltip" data-bs-placement="top" title={tipCount == 1 ? obj.comments : ''}>{commentsBind }</a></td> */}

                            {obj.emp_response == "Agreed" ? (<td className="text-center"><span className="status-btn bg-pastel-green">{obj.emp_response}</span></td>) : null}
                            {obj.emp_response == "Pending" || obj.emp_response == "pending" ? (<td className="text-center"><span className="status-btn bg-pastel-orange">{obj.emp_response}</span></td>) : null}
                            {obj.emp_response == "Disagree" ? (<td className="text-center"><span className="status-btn bg-pastel-red">{obj.emp_response}</span></td>) : null}

                            < td className="text-center"><a href={IsTeamMember == "true" ? `/Feedback?EmpId=${obj.emp_id}&FeedbackId=${obj.id}&EvaluationId=${obj.evaluation_id}&IsProfile=true&IsTeamMember=true` : `/Feedback?EmpId=${obj.emp_id}&FeedbackId=${obj.id}&EvaluationId=${obj.evaluation_id}&IsProfile=true&Status=${EmployeeStatus}`} className="text-decoration-none">View</a ></td>
                        </tr >

                    );

                });
            }

        } catch (e) {

        }
    };

    /**
    * 
    * PC_PFT_13 this function set the column name and column order
    */
    const sortClicked = (e) => {
        try {
            let sortID = e.target.id;
            let sortval = sortID.split("@");

            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);

        } catch (e) {

        }
    };

    /**
     * 
     * PC_PFT_22 tis function setstate the values into the variables
     */
    const OnChangeName = (e) => {

        setFilterData({ ...filterData, [e.target.name]: e.target.value });
    };

    /**
     * PC_PFT_23 this function clear the filter field values
     */

    const filterClearClicked = () => {

        let filter = {
            flags: "",
            empResponse: "",
            startDate: "",
            endDate: ""
        };

        setFilterData(filter);
        loadGridPage(filter);

    }





    const handleLoadMore = () => {
        try {
            setCoutPerPage(countPerPage + 10);
        } catch (e) {

        }
    }

    const addFeedbackClicked = () => {
        setHideFeedbackForm(false);
    }


    return (

        // <div className="row" id="feedbacks-tab-content" style={{ display: 'flex' }}>

        <>
            {/* <Loader isLoading={isLoading} /> */}
            <div>
                <div className="col-md-12 my-3 d-flex align-items-center ">
                    <h2 className="hive-title">Feedback</h2>
                    <div className="ms-auto d-flex">
                        {/*Filter Section Starts Here*/}
                        <div className="dropdown">
                            <button className="advanced-filter-button medium-text" type="button" id="feedback-filter-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src="/Images/filter-icon.svg" className="me-2" />Filter
                            </button>
                            <div className="dropdown-menu px-3 advanced-filter-panel" aria-labelledby="feedback-filter-dropdown">
                                <div className="row">
                                    <div className="col-md-12 py-2 border-0 mb-1"><span className="font-14 semibold-text advanced-filter-title">Advanced Filter</span>
                                        <button type="button" className="btn-close float-end close-filter" data-bs-dismiss="advanced-filter" aria-label="Close" />
                                    </div>
                                    <div className="col-md-12 ">
                                        <div className="row mb-3">

                                            <div className="col-md-6 mb-3 ">
                                                <label className="form-label hive-form-label" htmlFor="approval-status">Flags</label>
                                                <select className="form-select hive-form-control" id="approval-status"
                                                    name="flags" value={filterData.flags} onChange={(e) => { OnChangeName(e); }}>
                                                    <option value="">Select</option>
                                                    <option value="G" >Green</option>
                                                    <option value="Y" >Yellow</option>
                                                    <option value="R" >Red</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6 mb-3 ">
                                                <label className="form-label hive-form-label" htmlFor="approval-status">Response</label>
                                                <select className="form-select hive-form-control" id="approval-status"
                                                    name="empResponse" value={filterData.empResponse} onChange={(e) => { OnChangeName(e); }}>
                                                    <option value="">Select</option>
                                                    <option >Agreed</option>
                                                    <option >Disagree</option>
                                                    <option >Pending</option>
                                                </select>
                                            </div>

                                        </div>
                                        <div className="col-md-12 pb-2 border-0 ">
                                            <span className="font-14 semibold-text filter-title">Date Range</span>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="fromrange">From</label>
                                                <input type="date" className="form-control hive-form-control" id="fromrange"
                                                    name="startDate" value={filterData.startDate} max={filterData.endDate} onChange={(e) => { OnChangeName(e); }} />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label hive-form-label" htmlFor="torange">To</label>
                                                <input type="date" className="form-control hive-form-control" id="torange"
                                                    name="endDate" value={filterData.endDate} min={filterData.startDate} onChange={(e) => { OnChangeName(e); }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-12 my-3 d-flex justify-content-end">
                                        <button className="btn hive-btn-secondary"
                                            onClick={() => filterClearClicked()}>Clear</button>
                                        <button className="btn hive-btn-primary" onClick={() => loadGridPage()} >Apply</button>
                                    </div>
                                    {/* <div className="col-md-12 my-3 text-end">
                                    <button className="btn hive-btn-secondary" onClick={() => filterClearClicked()}>Clear</button>
                                    <button className="btn hive-btn-primary" onClick={() => loadGridPage()}>Apply</button>
                                </div> */}
                                </div>
                            </div>
                        </div>
                        {/*Filter Section Ends Here*/}
                        {(empId != login_id) && role != "Team Member" && role != "Hr" && props.reportingEmpIds.some(emp => emp.emp_id == empId) ? (<button className="btn hive-btn-primary ms-3" onClick={() => addFeedbackClicked()}
                        //  data-bs-toggle="modal" data-bs-target="#AddFeedbackDetailsPopup" 
                        >
                            <img className="me-2" src="/Images/profile-plus-action.svg" alt="Plus Icon" />Add Feedback</button>) : null}
                    </div>
                </div>
                <div className="col-md-12 mb-3">
                    <div className="card profile-border-grey">
                        <div className="card-body profile-justify-feedback">
                            <div className="profile-flag-panel">
                                <div className="profile-feedback-panel profile-feedback-green">
                                </div>
                                <div className="text-center profile-flag-count tt-bold">{indivFlagCountsData.green_flag ? indivFlagCountsData.green_flag : 0}</div>
                            </div>
                            <div className="profile-flag-panel">
                                <div className="profile-feedback-panel profile-feedback-yellow ">
                                </div>
                                <div className="text-center profile-flag-count tt-bold">{indivFlagCountsData.yellow_flag ? indivFlagCountsData.yellow_flag : 0}</div>
                            </div>
                            <div className="profile-flag-panel">
                                <div className="profile-feedback-panel profile-feedback-red">
                                </div>
                                <div className="text-center profile-flag-count tt-bold">{indivFlagCountsData.red_flag ? indivFlagCountsData.red_flag : 0}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="table-responsive">
                        <table className="table bg-white hive-grid table-borderless profile-regular-font">
                            <thead>
                                <tr>
                                    <th className="hive-table-head bold-text font-14">Feedback On<span className="ps-2">
                                        <img src="/Images/Sort-up.svg" className="hive-table-sort" id="feedbacks.modified_at@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedbacks.modified_at@ASC" ? true : false} />
                                        <img src="/Images/sort-icon.svg" className="hive-table-sort" id="feedbacks.modified_at@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedbacks.modified_at@ASC" ? false : true} />
                                    </span></th>
                                    <th className="hive-table-head text-center bold-text font-14">Flags</th>
                                    <th className="hive-table-head bold-text font-14">Feedback By<span className="ps-2">
                                        <img src="/Images/Sort-up.svg" className="hive-table-sort" id="feed_by.emp_name@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feed_by.emp_name@ASC" ? true : false} />
                                        <img src="/Images/sort-icon.svg" className="hive-table-sort" id="feed_by.emp_name@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feed_by.emp_name@ASC" ? false : true} />
                                    </span></th>
                                    <th className="hive-table-head bold-text font-14">Feedback<span className="ps-2">
                                        <img src="/Images/Sort-up.svg" className="hive-table-sort" id="feedback_data.comments_based_on@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedback_data.comments_based_on@ASC" ? true : false} />
                                        <img src="/Images/sort-icon.svg" className="hive-table-sort" id="feedback_data.comments_based_on@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedback_data.comments_based_on@ASC" ? false : true} />
                                    </span></th>
                                    <th className="hive-table-head bold-text font-14">Detailed Comments</th>
                                    <th className="hive-table-head text-center bold-text font-14">Response<span className="ps-2">
                                        <img src="/Images/Sort-up.svg" className="hive-table-sort" id="feedbacks.emp_response@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedbacks.emp_response@ASC" ? true : false} />
                                        <img src="/Images/sort-icon.svg" className="hive-table-sort" id="feedbacks.emp_response@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "feedbacks.emp_response@ASC" ? false : true} />
                                    </span></th>
                                    <th className="hive-table-head text-center bold-text font-14">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {feedbackGridBodyData()}
                            </tbody>
                        </table>
                    </div>
                    <div className="text-center">
                        {dataLength > countPerPage ? (<button className="btn bg-white font-14 medium-text mb-3" onClick={() => handleLoadMore()}>Show More</button>) : null}
                    </div>
                </div>
                {/* PC_PFT_12 AddFeedback is called from AddFeebbackForm.jsx */}
                <AddFeedback empId={empId} empName={props.emp_name} empDomain={props.emp_domain} ReloadGridPage={() => loadGridPage()} hideFeedbackForm={hideFeedbackForm} setHideFeedbackForm={() => setHideFeedbackForm()} />

            </div>
        </>

    );
}

export default ProfileFeedbackTabGrid;